import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const cid = () => getActiveCompanyId();
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getContractors = async () => unwrap((await axiosInstance.get(`/companies/${cid()}/contractors`)).data);
export const registerContractorPortalUser = async ({ email, password, contractorId }) =>
    (await axiosInstance.post(`/auth/register`, { email, password, role: 'Contractor', companyId: cid(), contractorId })).data;
export const getContractor = async (id) => (await axiosInstance.get(`/companies/${cid()}/contractors/${id}`)).data;
export const createContractor = async (p) => (await axiosInstance.post(`/companies/${cid()}/contractors`, p)).data;
export const updateContractor = async ({contractorId,...p}) => (await axiosInstance.put(`/companies/${cid()}/contractors/${contractorId}`, p)).data;
export const deleteContractor = async (id) => (await axiosInstance.delete(`/companies/${cid()}/contractors/${id}`)).data;

export const getContractorBankAccounts = async (contractorId) => {
    try {
        const res = (await axiosInstance.get(`/companies/${cid()}/contractors/${contractorId}/bank_accounts`, { params: { cursor: "0" } })).data;
        return Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);
    } catch {
        return [];
    }
};

export const createContractorBankAccount = async (contractorId, { accountType, ...rest }) => {
    return (await axiosInstance.post(`/companies/${cid()}/contractors/${contractorId}/bank_accounts`, { subtype: accountType, ...rest })).data;
};

export const updateContractorBankAccount = async (contractorId, accountId, { accountType, ...rest }) => {
    return (await axiosInstance.patch(`/companies/${cid()}/contractors/${contractorId}/bank_accounts/${accountId}`, { subtype: accountType, ...rest })).data;
};

export const deleteContractorBankAccount = async (contractorId, accountId) => {
    return (await axiosInstance.delete(`/companies/${cid()}/contractors/${contractorId}/bank_accounts/${accountId}`)).data;
};

const toSplitsArray = (res) => {
    const raw = Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);
    return Array.isArray(raw) ? raw : (raw && typeof raw === "object" ? Object.values(raw) : []);
};

export const getContractorNetPaySplits = async (contractorId) => {
    try {
        const res = (await axiosInstance.get(`/companies/${cid()}/contractors/${contractorId}/net-pay-splits`)).data;
        return toSplitsArray(res);
    } catch {
        try {
            const res = (await axiosInstance.get(`/companies/${cid()}/contractors/${contractorId}/net_pay_splits`, { params: { cursor: "0" } })).data;
            return toSplitsArray(res);
        } catch {
            try {
                const res = (await axiosInstance.post(`/companies/${cid()}/contractors/${contractorId}/net_pay_splits`, { cursor: 0 })).data;
                return toSplitsArray(res);
            } catch {
                return [];
            }
        }
    }
};

export const inviteContractor = async (contractorId) =>
    (await axiosInstance.post(`/companies/${cid()}/contractors/${contractorId}/invite`)).data;

export const createContractorNetPaySplit = async (contractorId, splits) => {
    const totalPercentage = splits
        .filter((s) => s.splitType === "percentage")
        .reduce((sum, s) => sum + (parseFloat(s.value) || 0), 0);
    const remainingPercent = Math.max(0, 100 - totalPercentage);
    const mapped = splits.map((s, i) => {
        const percent =
            s.splitType === "percentage"
                ? parseFloat(s.value) || 0
                : s.splitType === "remaining_balance"
                ? remainingPercent
                : 0;
        return {
            bank_account_id: s.bankAccountId,
            bankAccountId: s.bankAccountId,
            priority: i + 1,
            amount: s.splitType === "flat" ? parseFloat(s.value) || 0 : 0,
            percent,
        };
    });
    return (await axiosInstance.post(`/companies/${cid()}/contractors/${contractorId}/net_pay_splits`, { splits: mapped })).data;
};

